var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "p",
        {
          staticClass: "boss-table-title is-boss-only-pc",
          attrs: { "data-test": "label-company-name" },
        },
        [_vm._v(_vm._s(_vm.entryCompanyName))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "boss-layout-block" }, [
        _c(
          "div",
          { staticClass: "boss-table-wrap" },
          [
            _c("approached-summary", {
              attrs: { "approached-summaries": _vm.approachedSummaries },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-layout-block is-boss-only-pc" }, [
        _c(
          "div",
          { staticClass: "boss-layout boss-layout-start" },
          [
            _c("pdf-download", { attrs: { "entry-ids": [_vm.entryId] } }),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "boss-button",
                  attrs: { "data-test": "button-print-preview" },
                  on: { click: _vm.windowOpenPrintPreview },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/icon-print.svg"),
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("印刷")]),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("entry-detail-resume", {
        attrs: {
          "entry-id": _vm.entryId,
          "entry-company-name": _vm.entryCompanyName,
          "is-simple-entry-form": _vm.isSimpleEntryForm,
        },
      }),
      _vm._v(" "),
      _c("entry-detail-career-resume", {
        attrs: {
          "entry-id": _vm.entryId,
          "entry-company-name": _vm.entryCompanyName,
          "is-simple-entry-form": _vm.isSimpleEntryForm,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "pega-flex-center" }, [
        _c(
          "button",
          {
            staticClass: "boss-button boss-button-fill display-inline-flex",
            attrs: { "data-test": "remove-button" },
            on: { click: _vm.doRemove },
          },
          [_vm._v("この応募者情報を削除する（復活不可）")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }